import React, { useEffect, useState } from 'react';
import { Modal, Form, Row, Col, Button } from 'react-bootstrap';

import { sortBy } from 'lodash';

import ApiServiceServerless from '../../../xhr_libs';
import SmallerLoader from '../../SmallerLoader';


export default function SolarCreateAlsoEnergyMeterModal(props) {
  const {
    show,
    onHide,
    organization,
    solarProvider,
    subAccounts,
    setSubAccounts,
    updateAccess,
    activeLicense,
    showToast,
    setSolarMeters,
  } = props;


  const [meterName, setMeterName] = useState('');
  const [meterId, setMeterId] = useState('');
  const [hardwareId, setHardwareId] = useState('');
  const [subAccountId, setSubAccountId] = useState('')

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setMeterName('')
    setMeterId('')
    setHardwareId('')
    setSubAccountId('')
  }, [show])

  const handleSubmit = () => {
    setIsSaving(true);
    ApiServiceServerless.post(
      `/solar/link/${subAccountId}/link`,
      { meter_id: `${meterId}:${hardwareId}`, name: meterName, solar_active: true, organization_solar_provider_id: solarProvider.id },
      {
        authorization_id: organization.id,
      }
    )
      .then((res) => {
        setSubAccounts((prev) =>
          prev.map((sub_account) => {
            if (sub_account.id !== res.data[0].id) return sub_account;
            return res.data[0];
          })
        );
        setSolarMeters((prev) => [...prev, {
          'id': meterName + `${meterId}:${hardwareId}`,
          'meter_id': `${meterId}:${hardwareId}`,
          'name': meterName,
          'status': 'active',
          'solar_provider_id': solarProvider.solar_provider_id, 'organization_solar_provider_id': solarProvider.id
        }])
      })
      .catch((err) => {
        showToast('danger', 'Error', err);
        throw err;
      })
      .finally(() => {
        onHide();
        setIsSaving(false);
      });
  };


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>Create Solar Meter</Modal.Header>

      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Form.Group controlId='solar.formGridId'>
              <Form.Label>Site ID  </Form.Label>
              <Form.Control
                name='meterId'
                value={meterId}
                onChange={(e) => { setMeterId(e.target.value) }}
              />
            </Form.Group>
            <Form.Group controlId='solar.formGridId'>
              <Form.Label>Hardware ID  </Form.Label>
              <Form.Control
                name='hardwareId'
                value={hardwareId}
                onChange={(e) => { setHardwareId(e.target.value) }}
              />
            </Form.Group>
            <Form.Group controlId='solar.formGridNumber'>
              <Form.Label>Meter Name </Form.Label>
              <Form.Control
                name='meterName'
                value={meterName}
                onChange={(e) => { setMeterName(e.target.value) }}
              />
            </Form.Group>

            <Form.Group controlId='solar.formSubAccountLink'>
              <Form.Label>Linked EnergyTracer SubAccount</Form.Label>
              <Form.Row>
                <Col>
                  <Form.Control
                    as='select'
                    name='linkedSubAccount'
                    value={subAccountId}
                    onChange={(e) => {
                      setSubAccountId(e.target.value);
                    }}
                  >
                    <option key={'link-opt-null'} value={''} hidden>
                      -
                    </option>
                    {sortBy(
                      subAccounts.filter(
                        (sub_account) =>
                          !sub_account.solar_meter_id
                      ),
                      ['utility_account_name', 'name']
                    ).map((sub_account) => (
                      <option
                        key={`link-opt-${sub_account.id}`}
                        value={sub_account.id}
                      >
                        {sub_account.utility_account_name +
                          ' (' +
                          sub_account.name +
                          ')'}
                      </option>
                    ))}
                  </Form.Control>
                </Col>
              </Form.Row>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%' }}>
          {updateAccess && activeLicense && (
            <>
              <>
                <Button
                  data-id='btn_save'
                  type='submit'
                  variant='primary'
                  className='float-right ml-3'
                  onClick={() => handleSubmit()}
                  disabled={isSaving || meterName === "" || meterId === "" || hardwareId === "" || subAccountId === ""}
                >
                  {!isSaving && <>{'Submit'}</>}
                  {isSaving && <SmallerLoader text={'Submitting...'} />}
                </Button>
                <Button
                  data-id='btn_cancel'
                  type='button'
                  variant='outline-danger'
                  className='float-right'
                  onClick={() => onHide()}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
              </>
            </>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}
